
import React from 'react';
import '../MainPage/MainPage.less'
import './PrivacyInformation.less'
import { withTranslation } from 'react-i18next';

class PrivacyInformation extends React.Component {
    render() {
        const { t } = this.props;
        return (
            <div className='main_page privacyInformation'>
                <div className='user_files_container'>
                    <div className='user_files_list_header'>
                        <div className='user_files_list_header_left'>
                            <label id='Models'>{t('DataSecurityTitle')}</label>
                        </div>
                    </div>
                    <div className='user_files_list_container'>
                        <div className='user_files_list'>
                            <p>{t('DataSecurityText')}</p>
                            <br/>
                            <h3>{t('DataSecurityResponsibilityTitle')}</h3>
                            <br/>
                            <p>{t('DataSecurityResponsibilityText')}</p>
                            <br/>
                            <h3>{t('DataSecurityRightsTitle')}</h3>
                            <br/>
                            <p>{t('DataSecurityRightsText')}</p>
                            <br/>
                            <h3>{t('DataSecurityProcessingTitle')}</h3>
                            <br/>
                            <p>{t('DataSecurityProcessingText')}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withTranslation()(PrivacyInformation);
